<script setup lang="ts">
import './App.css';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import zhHK from 'ant-design-vue/es/locale/zh_HK';
import enUS from 'ant-design-vue/es/locale/en_US';
import idID from 'ant-design-vue/es/locale/id_ID';
import jaJP from 'ant-design-vue/es/locale/ja_JP';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { useRoute } from 'vue-router';
import myHeader from './components/header/header.vue';
import { store } from '@/store/index';
import pinia from '@/store/store';
import { ref, toRefs } from 'vue';
const { locale, locales } = useI18n();

let piniaStore = store(pinia);
piniaStore.setLang(locale.value);
const runtimeConfig = useRuntimeConfig();
const route = useRoute();
if (route.query.cid) {
	piniaStore.setChannelCid(route.query.cid as string);
} else {
	piniaStore.setChannelCid(runtimeConfig.public.nuxtChannelId);
}

let footerContent = ref<string>('');
let { showSpin } = toRefs(piniaStore);
const isShowSpin = ref(showSpin.value);
let lang = ref(piniaStore.getLang.toLowerCase());
if (process.client) {
	lang.value = piniaStore.getLang.toLowerCase();
}
let antdLang: any = ref({
	cn: zhCN,
	hk: zhHK,
	en: enUS,
	id: idID,
	ja: jaJP,
});
const antdLocale: any = ref(antdLang.value[lang.value]);
dayjs.locale(antdLocale.value.locale);

// ApiGetAll({}).then((res: any) => {
//   let cityList: any = formatCityAll(res)
//   piniaStore.setCityListAirport(cityList.cityListAirport)
//   piniaStore.setCityListObj(cityList.cityListObj)
//   piniaStore.setCountryList(cityList.countryList)
//   piniaStore.setAirportListArr(cityList.airportListArr)
// })

// 本地缓存方案
// const month = new Date().getMonth()
// let cityLocal: any = window.localStorage.getItem('cityList')
// if (cityLocal && JSON.parse(cityLocal).month == month) {
//   piniaStore.setCityList(JSON.parse(cityLocal).cityList)
// } else {
//   ApiGetCarrier({}).then((res: any) => {
//     piniaStore.setCarrierList(res)
//   })
//   // ApiGetCountry({}).then((res: any) => {
//   //   piniaStore.setCountryList(res)
//   // })
//   ApiGetAll({}).then((res: any) => {
//     let cityList: any = formatCityAll(res)
//     const tempCityLocal = {
//       month: month,
//       cityList: cityList.cityList
//     }
//     window.localStorage.setItem('cityList', JSON.stringify(tempCityLocal))
//     piniaStore.setCityList(cityList.cityList)
//     piniaStore.setCountryList(cityList.countryList)
//   })
// }

const subscribe = piniaStore.$subscribe((mutation, state) => {
	isShowSpin.value = state.showSpin;
	footerContent.value = state.content.pageFooter;
	if (process.client) {
		if (lang.value != state.lang?.toLowerCase()) {
			lang.value = state.lang?.toLowerCase();
			antdLocale.value = antdLang.value[lang.value];
			dayjs.locale(antdLocale.value?.locale);
		}
	}

	if (route.query.cid) {
		if (route.query.cid !== state.channelCid) {
			piniaStore.setChannelCid(route.query.cid as string);
		}
	}
});
</script>

<template>
	<a-config-provider :locale="antdLocale">
		<myHeader />
		<div class="app-main">
			<NuxtPage />
		</div>
		<client-only>
			<div class="spin-div" v-if="isShowSpin">
				<a-spin class="my-spin" size="large" />
			</div>
		</client-only>
		<client-only>
			<div class="footer-main" v-html="footerContent"></div>
		</client-only>
	</a-config-provider>
</template>

<style scoped>
.app-main {
	margin: 88px auto 0;
	position: relative;
}
</style>
